import { Spacer } from 'app/layouts/generic';
import { GridColumn, GridRow } from 'app/layouts/grid';
import React, { useEffect, useState } from 'react';
import { Button } from '../button';
import { DateRangePicker } from '../datepickers';
import { DetailItem } from '../info-section/item';
import { Checkbox } from '../input/checkbox';
import GmModal from '../modal/modal';
import { MultiSelect } from '../select';

export const TableFilter = ({
  config = {},
  is_open = false,
  onApply = () => {},
  onClose = () => {}
}) => {
  const [boolean_filters, setBooleanFilters] = useState([]);
  const [other_filters, setOtherFilters] = useState([]);
  const [selected_config, setSelectedConfig] = useState({});
  const [type_by_key, setTypeByKey] = useState({});

  useEffect(() => {
    if (!config.filters) return;
    const config_filters = config.filters || [];

    const bool_filters = [];
    const nonbool_filters = [];
    const key_types = {};
    config_filters.forEach((filter) => {
      if (filter.type === 'boolean') {
        setSelectedConfig((conf) => ({ ...conf, [filter.key]: false }));
        bool_filters.push(filter);
      } else {
        nonbool_filters.push(filter);
      }

      key_types[filter.key] = filter.type;
    });

    setBooleanFilters(bool_filters);
    setOtherFilters(nonbool_filters);
    setTypeByKey(key_types);
  }, [config.filters]);

  const determineFilter = (config = {}) => {
    switch (config.type) {
      case 'boolean':
        return (
          <Checkbox
            label={config.label}
            checked={!!selected_config[config.key]}
            onClick={() =>
              setSelectedConfig((conf) => ({ ...conf, [config.key]: !conf[config.key] }))
            }
          />
        );
      case 'multichoice':
        return (
          <MultiSelect
            options={config.value}
            value={selected_config[config.key] || []}
            onChange={(selections) => {
              setSelectedConfig((conf) => ({ ...conf, [config.key]: selections }));
            }}
            isMulti
            isSorted
          />
        );
      case 'range':
        return (
          <DateRangePicker
            clear_date={Object.keys(selected_config).length === 0}
            onChange={(values) => setSelectedConfig((conf) => ({ ...conf, [config.key]: values }))}
          />
        );
      default:
        return <div key={config.label}>{config.label}</div>;
    }
  };

  const handleClear = () => {
    setSelectedConfig(() => ({}));
    onApply('&');
    onClose();
  };

  const handleSave = () => {
    const boolean_fields = [];
    let query = '';
    let min;
    let max;

    for (const field of Object.keys(selected_config)) {
      if (selected_config[field] === undefined) continue;
      switch (type_by_key[field]) {
        case 'boolean':
          boolean_fields.push(selected_config[field] ? field : `-${field}`);
          break;
        case 'range':
          min = isNaN(selected_config[field][0])
            ? Date.parse(selected_config[field][0])
            : selected_config[field][0];
          max = isNaN(selected_config[field][1])
            ? Date.parse(selected_config[field][1]) + 86400000
            : selected_config[field][1];
          query = `${query}${query.length > 0 ? '&' : ''}${field}=${min}~${max}`;
          break;
        case 'multichoice':
          query = `${query}${query.length > 0 ? '&' : ''}${field}=${selected_config[field]
            .map((selection) => selection.value)
            .join(',')}`;
          break;
      }
    }

    if (boolean_fields.length > 0) {
      query = `${query}${query.length > 0 ? '&' : ''}bool=${boolean_fields.join(',')}`;
    }

    onApply(query);
    onClose();
  };

  return (
    <GmModal
      position="right"
      show_modal={is_open}
      show_title={true}
      title={config.title}
      onClose={onClose}
    >
      {boolean_filters.map((filter) => (
        <GridRow key={filter.title} num_of_columns={1}>
          <GridColumn>
            <DetailItem>{determineFilter(filter)}</DetailItem>
          </GridColumn>
        </GridRow>
      ))}
      {other_filters.map((filter) => (
        <GridRow key={filter.title} num_of_columns={1}>
          <GridColumn>
            <DetailItem title={filter.label}>{determineFilter(filter)}</DetailItem>
          </GridColumn>
        </GridRow>
      ))}
      <Spacer multiple={4} />
      <GridRow num_of_columns={2}>
        <GridColumn>
          <Button text="Clear filters" type="secondary" onClick={handleClear} />
        </GridColumn>
        <GridColumn>
          <Button text="Apply filters" onClick={handleSave} />
        </GridColumn>
      </GridRow>
    </GmModal>
  );
};
